import { defineComponent, h } from 'vue';
import BaseComponent from './BaseComponentMixin.jsx';
import AccordionGroup from './AccordionGroup';
import EventBus from '../event-bus.js';

import _ from 'lodash';
import utils from '../../Shared/utils.jsx';
import methods from '../../Shared/methods';

export default defineComponent({
    name: 'accordion',
    mixins: [BaseComponent],
    components: {
        AccordionGroup,
    },
    data: function () {
        return {
            closeOthersEval: null,
            accordionGroupEvals: null,
            openedItems: []
        }
    },
    computed: {
        closeOthers() {
            try {
                if(this.closeOthersEval === null && this.controlData.CloseOthers)
                    this.closeOthersEval = utils.compile(this, this.Translate(this.controlData.CloseOthers));
                if(this.closeOthersEval)
                    return utils.evaluate(this.closeOthersEval, this);
                return '';
            }
            catch (e) {
                utils.warn('CloseOthers could not evaluate expression: ' + this.controlData.CloseOthers + '; ' + e);
                return '';
            }
        },
        styles() {
            return {
                ...this.sizeStyle,
                ...utils.resolveStyleHints(this.styleHints, this),
            };
        }
    },
    //Mounted Replaced with preRenderComplete
    methods: {
        onGroupModelValue(index, isOpen) {
            if (isOpen)
                this.openItem(index);
            else
                this.closeItem(index);
        },
        openItem(index) {
            if (this.closeOthers)
                this.openedItems = [index];
            else if (!this.openedItems.includes(index)) {
                utils.debug(`Accordion ${this.name} openItem(index:${index})`);
                this.openedItems.push(index)
            }
        },
        closeItem(index) {
            if(this.openedItems.includes(index))
                this.openedItems = this.openedItems.filter(item => item != index);
        },
        preRenderComplete() {
            if (this.controlData.AccordionGroup) {
                this.openedItems = this.controlData.AccordionGroup.map((v, i) => {
                    if (v.IsOpen)
                        return i;
                    return -1;
                }).filter(v => v > -1);
            }

            this.finishRenderHandler(this);
        }
    },
    props: {
    },
    render() {
        try {
            return (
                <div class={{ 'c-Accordion': true, [`c-name-${this.name || 'unnamed'}`]: true }}
                    v-show={this.isvisible} style={this.styles}>
                    {this.controlData.AccordionGroup.map((groupItem, index) => {
                        return (
                            <AccordionGroup
                                controlData={groupItem}
                                parentType="Accordion"
                                name={groupItem.Name}
                                type="AccordionGroup"
                                value={index}
                                isOpen={this.openedItems.includes(index)}
                                scopeitems={this.scopeitems}
                                controlscope={this.controlscope}
                                onOpen={() => this.openItem(index)}
                                onClose={() => this.closeItem(index)}
                                onUpdate:isOpen={(isOpen) => this.onGroupModelValue(index, isOpen)}
                                onFinishedRender={(reference) => this.finishRenderHandler(reference)}
                                root={this.root}
                            ></AccordionGroup>
                        )
                    })}
                </div>
            );
        }
        catch(e) {
            utils.error('Accordion Render failed', e);
            return <div>Accordion Failed to Render {e}</div>;
        }
    }
});